import React, { useMemo, useCallback, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormSelect } from "@shoutout-labs/shoutout-themes-enterprise";
import { MonthsOptions } from "Utils";
import MonthPicker from "../monthPicker/MonthPicker";
import "./YearMonthSelector.scss";

const years = Array.from({ length: 40 }, (_, i) => ({
    value: String(2000 + i),
    label: String(2000 + i),
}));

const YearMonthSelector = ({ value, onChange, disabled = false, field }) => {
    const [year, setYear] = useState("");
    const [month, setMonth] = useState("");

    const selectedYear = useMemo(
        () =>
            year
                ? years.filter((y) => y.value === year).map((y) => ({ value: y.value, label: y.label }))
                : [],
        [year],
    );

    const selectedMonth = useMemo(
        () =>
            month
                ? MonthsOptions.filter((m) => m.value === month).map((m) => ({ value: m.value, label: m.label }))
                : [],
        [month],
    );

    const handleYearChange = useCallback((selected) => {
        setYear(selected[0]?.value || "");
        const newValue = `${selected[0]?.value || ""}-${month}`;
        onChange(newValue);
    }, [onChange, month]);

    const handleMonthChange = useCallback((selected) => {
        setMonth(selected[0]?.value || "");
        const newValue = `${year}-${selected[0]?.value || ""}`;
        onChange(newValue);
    }, [onChange, year]);


    useEffect(() => {
        setYear(value.split("-")[0] || "");
        setMonth(value.split("-")[1] || "");
        // eslint-disable-next-line
    }, []);

    return (
        <div className="year-month-selector" id={field}>
            <FormSelect
                options={years}
                placeholder="Select a year"
                multiple={false}
                selected={selectedYear}
                clearButton
                disabled={disabled}
                onChange={handleYearChange}
                required
            />
            <MonthPicker
                selected={selectedMonth}
                disabled={disabled}
                onChange={handleMonthChange}
            />
        </div>
    );
};

YearMonthSelector.defaultProps = {
    value: "",
    disabled: false,
    onChange: () => {
    },
    field: "",
};

YearMonthSelector.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    field:PropTypes.string
};

export default React.memo(YearMonthSelector);
